import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {filterChange} from "../../features/filter/filterSlice";

export default function Filter() {
  const {filter} = useSelector((state) => state.filter);  
  const dispatch = useDispatch();
  return (
    <div className="flex items-center justify-between mb-12">
      <h4 className="mt-2 text-xl font-bold">Book List</h4>
      <div className="flex items-center space-x-4">
        <button className={`lws-filter-btn ${filter==='All' && 'active-filter'}`} onClick={()=>dispatch(filterChange('All'))}  >All</button>
        <button className={`lws-filter-btn ${filter==='Featured' && 'active-filter'}`} onClick={()=>dispatch(filterChange('Featured'))} >Featured</button>
      </div>
    </div>
  );
}
